import Shows from '../components/Shows'

function Home() {

  return (
  	<div className="page">
			<br />
	    <header className="home-header">
		    <div>
		      Upcoming Shows
		    </div>
	    </header>

	    <Shows 
	    	filterShows={s => s.ts > Date.now()}
			sortShows={true}
	    />


    </div>
  )
}

export default Home
